import {
  ApiGetChannelInfoByIdPayload,
  ApiGetChannelInfoByIdResponse
} from './type'
import { GlobalService } from '@/context'
import siteConfig from '@/config/site.config'

/**根据渠道id决定是否提示App下载弹出框 */
export const apiGetChannelInfoById = (
  payload: ApiGetChannelInfoByIdPayload
) => {
  return GlobalService.get<ApiGetChannelInfoByIdResponse>({
    url: '/api/lobby/channel/go/getChannelInfoById',
    params: {
      siteCode: siteConfig.siteCode,
      ...payload
    },
    customParams: {
      noEncrypt: true,
      staticKeyOmit: ['language', 'platformType', 'currency'],
      tryStaticMode: true
    }
  }).then((result) => result?.data?.data)
}
